<template>
  <div class="Faq">
    <section-header heading="2" ja="よくある質問"/>
    <normal-btn @click="onAboutWeb">プリクラONについて</normal-btn>
    <normal-btn @click="onAboutTotolu">totoluについて</normal-btn>
    <normal-btn @click="onAboutGimmi">GIMMIについて</normal-btn>
    <normal-btn @click="onAboutRomakyun">romakyunについて</normal-btn>
    <normal-btn @click="onAboutLalamee">lalameeについて</normal-btn>
    <sub-btn @click="onBack">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import NormalBtn from '@/components/NormalBtn.vue'
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "Faq",
  components: {
    SectionHeader,
    NormalBtn,
    SubBtn
  },
  mounted () {
    sessionStorage.setItem('prevPage', '/Faq');
  },
  methods: {
    onAboutWeb() {
      this.$router.push("/AboutWeb")
    },
    onAboutFiz() {
      this.$router.push("/AboutFiz")
    },
    onAboutMeiroma() {
      this.$router.push("/AboutMeiyromantic")
    },
    onAboutLalamee() {
      this.$router.push("/AboutLalamee")
    },
    onAboutROMAPI() {
      this.$router.push("/AboutROMAPI")
    },
    onAboutBepiu() {
      this.$router.push("/AboutBepiu")
    },
    onAboutIMyMerry() {
      this.$router.push("/AboutIMyMerry")
    },
    onAboutRomakyun() {
      this.$router.push("/AboutRomakyun")
    },
    onAboutGimmi(){
      this.$router.push("/AboutGimmi")
    },
    onAboutTotolu(){
      this.$router.push("/AboutTotolu")
    },
    onBack() {
      this.$router.push('/Help')
    },
  }
}
</script>

<style scoped>
</style>
